import script from "./DashboardNav.vue?vue&type=script&setup=true&lang=js"
export * from "./DashboardNav.vue?vue&type=script&setup=true&lang=js"

import "./DashboardNav.vue?vue&type=style&index=0&id=bd6342d0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bd6342d0"]])

export default __exports__